module.exports = __webpack_public_path__ + "img/emo_18.8ae6b6ec.gif";